import { WhoOptionsAirway } from "./WhoOptionsAirway";
import { WhoOptionsNonAdult } from "./WhoOptionsNonAdult";
import { WhoOptionsSurgery } from "./WhoOptionsSurgery";
import { WhoOptionsTrueFalse } from "./WhoOptionsTrueFalse";
import { WhoOptionsYesNo } from "./WhoOptionsYesNo";
import { WhoOptionsYesNoNA } from "./WhoOptionsYesNoNA";
import { WhoOptionsYesNoNone } from "./WhoOptionsYesNoNone";

export class WhoChecklist {
    patientTheatreVisitId: number;
    q6Options?: WhoOptionsYesNo;
    q6aOptions?: WhoOptionsNonAdult[];
    q7Options?: WhoOptionsSurgery[];
    q8Options?: WhoOptionsYesNo;
    q9Options?: WhoOptionsYesNo;
    q10Options?: WhoOptionsYesNo;
    q11Options?: WhoOptionsYesNo;
    q12Options?: WhoOptionsYesNo;
    q13Options?: WhoOptionsTrueFalse;
    q14Options?: WhoOptionsYesNo;
    q15Options?: WhoOptionsYesNo;
    q16Options?: WhoOptionsYesNo;
    q17Options?: WhoOptionsYesNo;
    q18Options?: WhoOptionsYesNo;
    q19Options?: WhoOptionsTrueFalse;
    q20Options?: WhoOptionsYesNoNA;
    q21Options?: WhoOptionsYesNoNA;
    q22Options?: WhoOptionsYesNo;
    q23Options?: WhoOptionsTrueFalse;
    q24Options?: WhoOptionsYesNoNA;
    q25Options?: WhoOptionsYesNo;
    q26Options?: WhoOptionsYesNo;
    q27Options?: WhoOptionsAirway;
    q28Options?: WhoOptionsTrueFalse;
}